(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8481],{

/***/ 90958:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa",
      function () {
        return __webpack_require__(28259);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);



/* @jsxRuntime classic */ /* @jsx mdx */ 

var meta = {};
var slug = "_bfeatures";
var tableOfContents = [
    {
        "title": "Features",
        "slug": "features",
        "children": []
    },
    {
        "title": "Why Tradly Vs Other Booking Platforms?",
        "slug": "why-tradly-vs-other-booking-platforms",
        "children": []
    },
    {
        "title": "Is any of the important feature missing?",
        "slug": "is-any-of-the-important-feature-missing",
        "children": []
    },
    {
        "title": "Pricing",
        "slug": "pricing",
        "children": []
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "features",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Features"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Host under your custom domain or hosted under tradly.co subdomain"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Payments "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Tickets / Inventory Controls "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Ticket Variances, so you can have variety of sub-tickets under events"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Repeated Events. Configure repeat events with a flexible time chooser under the same event, so you don’t need to create different events for different time"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Granular control on events: Add images, title and description on each event variance level "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Configure custom SEO")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "why-tradly-vs-other-booking-platforms",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Why Tradly Vs Other Booking Platforms?"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Multi Account like a marketplace"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Allow account manager to manage their own events and Profile"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Unlimited number of events"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Unlimited staff under your admin panel"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Unlimited number of users in your platform "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Video listings "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Continous improvements of features and releases every quarter"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Create Collections to group events"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Create internal promotions to promote specific event or account"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Developer Focused Headless API and toolkits")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "is-any-of-the-important-feature-missing",
        nextElement: {
            "type": "paragraph"
        }
    }, "Is any of the important feature missing?"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Do you think any fundamental feature is missing for you to move forward with Tradly?\nLet us know, we are curious to know what it is and add in our Roadmap. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "pricing",
        nextElement: {
            "type": "paragraph"
        }
    }, "Pricing"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Starts with a free pricing and has a fair price increment based on your growth."));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 66080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);



/* @jsxRuntime classic */ /* @jsx mdx */ 

var meta = {};
var slug = "_channel";
var tableOfContents = [
    {
        "title": "Channels which you can allow booking",
        "slug": "channels-which-you-can-allow-booking",
        "children": []
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "channels-which-you-can-allow-booking",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "Channels which you can allow booking"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Website "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Android App"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "iOS App"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "iPad App "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Android Kiosk App")));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 52861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);



/* @jsxRuntime classic */ /* @jsx mdx */ 

var meta = {};
var slug = "_checklist";
var tableOfContents = [
    {
        "title": "For developers",
        "slug": "for-developers",
        "children": []
    },
    {
        "title": "5 Steps for no-code creators and builders",
        "slug": "5-steps-for-no-code-creators-and-builders",
        "children": [
            {
                "title": "Advanced Informations",
                "slug": "advanced-informations",
                "children": []
            },
            {
                "title": "A. UI Customisation via SuperAdmin",
                "slug": "a-ui-customisation-via-super-admin",
                "children": []
            },
            {
                "title": "B. Platform Fundamentals",
                "slug": "b-platform-fundamentals",
                "children": []
            },
            {
                "title": "C. Integrations",
                "slug": "c-integrations",
                "children": []
            },
            {
                "title": "App integrations",
                "slug": "app-integrations",
                "children": []
            },
            {
                "title": "System integrations",
                "slug": "system-integrations",
                "children": []
            },
            {
                "title": "Website Integrations",
                "slug": "website-integrations",
                "children": []
            }
        ]
    }
];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Checklist from start to end on what you need to build a marketplace using Tradly Platform."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Tradly Platform solution is catered to different groups separately"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "For developers: ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://tradly.app"
    }), "Headless API solution"), ". Using the API solution, developers can build apps on top of it."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "For no-code creators: A simple toggle based SuperAdmin Panel to configure features in the already pre-built apps (also called as storefront, front end apps, templated apps).")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "for-developers",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "For developers"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://tradly.app/signup"
    }), "Signup for a free account")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Get the API keys in the SuperAdmin > Settings > API section = Refer the ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://developer.tradly.app"
    }), "API reference"), " to start building the app"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Optionally Fork ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "li"
    }, {
        "href": "https://github.com/TRADLY-PLATFORM"
    }), "Open source app starter Kits"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 2,
        id: "5-steps-for-no-code-creators-and-builders",
        nextElement: {
            "type": "list",
            "ordered": true,
            "start": 1,
            "spread": true
        }
    }, "5 Steps for no-code creators and builders"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://tradly.app/signup"
    }), "Signup for a free account"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Choose the templates ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://tradly.app/templates"
    }), "Website or Mobile Apps")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: "/img/templates.png",
        alt: "Templates Gallery",
        width: "600"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Do the branding customisation & business informations on ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://tradly.app/editor"
    }), "launchpad"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Prototype your app using our SuperAdmin builder and ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://tradly.app/docs/testingapp"
    }), "Visualise your app through test apps."))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Launch"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Web App: By default when you register, you will get the production URL to use the app. And you can add custom domain. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Mobile App: When you are ready to launch, Subscribe to our plans and get a white label app build")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "advanced-informations",
        nextElement: {
            "type": "heading",
            "depth": 3
        }
    }, "Advanced Informations"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "a-ui-customisation-via-super-admin",
        nextElement: {
            "type": "paragraph"
        }
    }, "A. UI Customisation via SuperAdmin"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Settings > App Customistion"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "App Name"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "App Primary & Secondary Colour"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "App Icon"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Splash launch images"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Onboarding images, Onboarding Text"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Registration Text"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Sell Icon (optional)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "App title in Home Screen (Default will be app name) And others", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: "/img/superadmin-builder.png",
        alt: "Superadmin builder",
        width: "600"
    }))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "b-platform-fundamentals",
        nextElement: {
            "type": "paragraph"
        }
    }, "B. Platform Fundamentals"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "You must configure the below things for the system to be able to open accounts, submit listings and make purchases."), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Configure accounts: Settings > accounts(categories, attributes)")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Configure listings: Settings > listings (Setting up listings information to be collected. Categories, attributes)"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: "/img/listing-configuration.png",
        alt: "listing configuration",
        width: "600"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Stripe/other payment gateways configuration"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: "/img/payments.png",
        alt: "payments",
        width: "600"
    })), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Configure revenue model, commissions: Settings > commissions OR Settings > Subscriptions OR Settings > Special Fees"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "c-integrations",
        nextElement: {
            "type": "heading",
            "depth": 3
        }
    }, "C. Integrations"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "app-integrations",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "App integrations"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Chat setup via Firebase ,"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Optionally referral / sharing features via Branch"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Optionally later legal informations (privacy, terms, etc)", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: "/img/appintegrations.png",
        alt: "App Integrations",
        width: "600"
    }))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "system-integrations",
        nextElement: {
            "type": "list",
            "ordered": false,
            "start": null,
            "spread": false
        }
    }, "System integrations"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ul", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Configure email if you want the emails to be whitelisted"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Configure domain if you want good deliverability of emails"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ul"
    }, "Configure Google Maps if you have location specific features")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_components_Heading__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X, {
        level: 3,
        id: "website-integrations",
        nextElement: {
            "type": "jsx"
        }
    }, "Website Integrations"), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        src: "/img/webintegrations.png",
        alt: "Website Integrations",
        width: "600"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "Dozens of website integrations to help you with marketing, analytics and products. ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://tradly.app/integrations"
    }), "Check here")));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 74861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MDXContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3905);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5679);
/* harmony import */ var _Shared_TemplatesCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85227);



/* @jsxRuntime classic */ /* @jsx mdx */ 


var meta = {};
var slug = "_how";
var tableOfContents = [];
var layoutProps = {
    meta: meta,
    slug: slug,
    tableOfContents: tableOfContents
};
var MDXLayout = "wrapper";
function MDXContent(_param) {
    var components = _param.components, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "components"
    ]);
    return /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(MDXLayout, Object.assign({}, layoutProps, props, {
        components: components,
        mdxType: "MDXLayout"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "CREATE a FREE BOOKING Website in just few steps. "), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Sign Up with a ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://tradly.app/signup"
    }), "free account")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/signup-tradly.png"
    }))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Select any templates"))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)(_Shared_TemplatesCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        template_id: [
            11103,
            10463
        ],
        title: "Event Booking Templates",
        isShowBtn: false,
        mdxType: "TemplatesCards"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "start": 3,
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Customise the styling using Simple ", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("a", Object.assign({
        parentName: "p"
    }, {
        "href": "https://tradly.app/editor"
    }), "Website Editor")), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/customisation-store.png"
    }))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", {
        parentName: "li"
    }, "Create Events with images, descriptions and other optional rules "))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("ol", Object.assign({}, {
        "start": 5,
        "role": "list"
    }), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("li", {
        parentName: "ol"
    }, "Optional ", "[Add Payment Gateways]", /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("div", {
        class: "relative"
    }, /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("img", {
        class: "w-full h-82 object-cover rounded-lg shadow-lg",
        src: "/img/payment-store.png"
    })))), /*#__PURE__*/ (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_1__/* .mdx */ .kt)("p", null, "That’s it. You can start receiving bookings. "));
}
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps;


/***/ }),

/***/ 85227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70441);
/* harmony import */ var constant_functions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60538);








var TemplatesCards = function(param) {
    var template_id = param.template_id, category_id = param.category_id, title = param.title, isShowBtn = param.isShowBtn, template_btn_title = param.template_btn_title;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), templates = ref[0], setTemplates = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var params = {
            page: 1
        };
        if (category_id) {
            params.category_id = category_id;
        }
        axios__WEBPACK_IMPORTED_MODULE_1___default().get("/api/all_templates", {
            params: params
        }).then(function(res) {
            setTemplates(res.data.data.listings);
        });
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: " ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex justify-between items-center my-5 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        className: "h4 m-0 text-black font-semibold",
                        children: (title === null || title === void 0 ? void 0 : title.length) > 0 && title
                    }),
                    isShowBtn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: {
                            pathname: "/templates"
                        },
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "btn-sm bg-primary hover:bg-transparent text-white hover:text-primary ",
                            children: "See All"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid gap-12 md:grid-cols-3 md:gap-x-6 md:gap-y-8 items-start",
                children: templates === null || templates === void 0 ? void 0 : templates.map(function(item) {
                    var Type = function(attributes) {
                        var ref, ref1;
                        return (ref1 = (ref = attributes.filter(function(at) {
                            return at.name === "Type";
                        })[0]) === null || ref === void 0 ? void 0 : ref.values[0]) === null || ref1 === void 0 ? void 0 : ref1.name;
                    };
                    // is_active
                    var is_active = function(attributes) {
                        var ref;
                        return ((ref = attributes.filter(function(at) {
                            return at.name === "Active";
                        })[0]) === null || ref === void 0 ? void 0 : ref.values[0]) == true ? true : undefined;
                    };
                    if ((template_id === null || template_id === void 0 ? void 0 : template_id.length) > 0) {
                        if (template_id.includes(item.id) && is_active(item.attributes)) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col h-full sha rounded-md overflow-hidden border border-[#eaeaea] hover:shadow-medium p-3 transition-all duration-300",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                                        className: "mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: " w-full h-[200px] block relative mb-5 overflow-hidden ",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: "w-full h-full object-cover object-top ",
                                                    src: (0,constant_functions__WEBPACK_IMPORTED_MODULE_6__.getThumbnailImage)(item.images[0]),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: " px-2 text-xl font-bold leading-snug tracking-tight mt-0 mb-2 text-center",
                                                children: item.title.length > 20 ? item.title.substr(0, 20) + ".." : item.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/templates/".concat(item.slug),
                                            className: "btn w-full bg-primary hover:bg-white text-white hover:text-primary border border-transparent hover:border-primary transition duration-300 ",
                                            onClick: function() {
                                                var _obj;
                                                (0,constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelTracking */ .n5)(constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelEventName.click_template_on_embed */ .aK.click_template_on_embed, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelPropertiesName.referrer */ .Oe.referrer, router.pathname), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelPropertiesName.template_slug */ .Oe.template_slug, item.slug), _obj));
                                            },
                                            children: template_btn_title ? template_btn_title : "GET TEMPLATE"
                                        })
                                    })
                                ]
                            });
                        }
                    } else {
                        if (is_active(item.attributes)) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col h-full sha rounded-md overflow-hidden border border-[#eaeaea] hover:shadow-medium p-3 transition-all duration-300",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                                        className: "mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: " w-full h-[200px] block relative mb-5 overflow-hidden ",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: "w-full h-full object-cover object-top ",
                                                    src: (0,constant_functions__WEBPACK_IMPORTED_MODULE_6__.getThumbnailImage)(item.images[0]),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: " px-2 text-xl font-bold leading-snug tracking-tight mt-0 mb-2 text-center",
                                                children: item.title.length > 20 ? item.title.substr(0, 20) + ".." : item.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/templates/".concat(item.slug),
                                            className: "btn w-full bg-primary hover:bg-white text-white hover:text-primary border border-transparent hover:border-primary transition duration-300 ",
                                            onClick: function() {
                                                var _obj;
                                                (0,constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelTracking */ .n5)(constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelEventName.click_template_on_embed */ .aK.click_template_on_embed, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelPropertiesName.referrer */ .Oe.referrer, router.pathname), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_5__/* .MixpanelPropertiesName.template_slug */ .Oe.template_slug, item.slug), _obj));
                                            },
                                            children: template_btn_title ? template_btn_title : "GET TEMPLATE"
                                        })
                                    })
                                ]
                            });
                        }
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TemplatesCards);


/***/ }),

/***/ 80368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99741);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(constant_url__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44835);
/* harmony import */ var react_typed__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27788);
/* harmony import */ var react_typed__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_typed__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var constant_functions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60538);
/* harmony import */ var _pages_api_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10107);
/* harmony import */ var constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70441);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_9__);











function FleetHome() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), videoModalOpen = ref[0], setVideoModalOpen = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), userDetails = ref1[0], setUserDetails = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), tenantDetails = ref2[0], setTenantDetails = ref2[1];
    // user Details and tenant details fetching
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if ((0,constant_functions__WEBPACK_IMPORTED_MODULE_6__.getAuthKey)() !== undefined) {
            var auth_key = (0,constant_functions__WEBPACK_IMPORTED_MODULE_6__.getAuthKey)();
            if (auth_key) {
                (0,_pages_api_api__WEBPACK_IMPORTED_MODULE_7__/* .getUserDetails */ .M_)(auth_key).then(function(res) {
                    if (res === null || res === void 0 ? void 0 : res.user) {
                        setUserDetails(res.user);
                    }
                });
                axios__WEBPACK_IMPORTED_MODULE_9___default().get("/api/user_tenants_details", {
                    params: {
                        auth_key: (0,constant_functions__WEBPACK_IMPORTED_MODULE_6__.getAuthKey)()
                    }
                }).then(function(res) {
                    setTenantDetails((0,constant_functions__WEBPACK_IMPORTED_MODULE_6__.getSelectedTenantDetails)(res.data.data.tenants));
                }).catch(function(err) {
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    (err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.error) === null || ref2 === void 0 ? void 0 : ref2.message) && alert(err === null || err === void 0 ? void 0 : (ref3 = err.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.error) === null || ref5 === void 0 ? void 0 : ref5.message);
                });
            }
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none z-[-1]",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    width: "1360",
                    height: "578",
                    viewBox: "0 0 1360 578",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                                x1: "50%",
                                y1: "0%",
                                x2: "50%",
                                y2: "100%",
                                id: "illustration-01",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        stopColor: "#FFF",
                                        offset: "0%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        stopColor: "#ccfbf1",
                                        offset: "77.402%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        stopColor: "#f0fdfa",
                                        offset: "100%"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            fill: "url(#illustration-01)",
                            fillRule: "evenodd",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                    cx: "1232",
                                    cy: "128",
                                    r: "128"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                    cx: "155",
                                    cy: "443",
                                    r: "64"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-6xl mx-auto px-4 sm:px-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "pt-16 pb-12 md:pt-20 md:pb-20",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                            className: "text-center text-3xl font-normal leading-tighter tracking-wider",
                            children: [
                                "A Fleet Platform for",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_typed__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    className: "bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400",
                                    strings: [
                                        " Grocery Delivery",
                                        " Food Delivery",
                                        " Recycle Management",
                                        " Anything you can imagine!", 
                                    ],
                                    typeSpeed: 50,
                                    backSpeed: 100,
                                    loop: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "text-center pb-12 md:pb-16",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                    className: "text-5xl md:text-6xl font-extrabold leading-tighter tracking-tighter mb-4 ",
                                    "data-aos": "zoom-y-out",
                                    children: [
                                        " ",
                                        "A simple & Easy way to launch",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400",
                                            children: "your Fleet Operations."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "max-w-3xl mx-auto",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-xl text-gray-600 mb-8",
                                            "data-aos": "zoom-y-out",
                                            "data-aos-delay": "150",
                                            children: "A Super Simple way to onboard your stores/storage points, location, drivers and vehicles. Special App for your Drivers. And you can manage your biz from the SuperAdmin"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "max-w-xs mx-auto sm:max-w-none sm:flex sm:justify-center",
                                            "data-aos": "zoom-y-out",
                                            "data-aos-delay": "300",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        className: "btn text-white bg-blue-600 hover:bg-blue-700 w-full mb-4 sm:w-auto sm:mb-0",
                                                        href: "/signup",
                                                        onClick: function() {
                                                            var _obj;
                                                            (0,constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__/* .MixpanelTracking */ .n5)(constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__/* .MixpanelEventName.homepage_template */ .aK.homepage_template, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__/* .MixpanelPropertiesName.user_name */ .Oe.user_name, userDetails === null || userDetails === void 0 ? void 0 : userDetails.name), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__/* .MixpanelPropertiesName.user_email */ .Oe.user_email, userDetails === null || userDetails === void 0 ? void 0 : userDetails.email), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__/* .MixpanelPropertiesName.tenant_name */ .Oe.tenant_name, tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.id), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__/* .MixpanelPropertiesName.homepage_sticky_buttons_property */ .Oe.homepage_sticky_buttons_property, constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__/* .MixpanelPropertiesValues.homepage_sticky_get_started */ .JA.homepage_sticky_get_started), _obj));
                                                        },
                                                        children: "Start Building For Free"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        className: "btn_outline hover:text-white border border-gray-900 hover:bg-gray-800 w-full sm:w-auto sm:ml-4",
                                                        href: "https://tradly.app/docs",
                                                        onClick: function() {
                                                            var _obj;
                                                            (0,constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__/* .MixpanelTracking */ .n5)(constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__/* .MixpanelEventName.homepage_template */ .aK.homepage_template, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__/* .MixpanelPropertiesName.user_name */ .Oe.user_name, userDetails === null || userDetails === void 0 ? void 0 : userDetails.name), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__/* .MixpanelPropertiesName.user_email */ .Oe.user_email, userDetails === null || userDetails === void 0 ? void 0 : userDetails.email), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__/* .MixpanelPropertiesName.tenant_name */ .Oe.tenant_name, tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.id), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__/* .MixpanelPropertiesName.homepage_sticky_buttons_property */ .Oe.homepage_sticky_buttons_property, constant_mixpnael__WEBPACK_IMPORTED_MODULE_8__/* .MixpanelPropertiesValues.homepage_sticky_documentation */ .JA.homepage_sticky_documentation), _obj));
                                                        },
                                                        children: "Documentation"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FleetHome);


/***/ }),

/***/ 28259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_TradlyHome_FleetHome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80368);
/* harmony import */ var _components_Header2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15592);
/* harmony import */ var _partials_TradlyFooter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48777);
/* harmony import */ var _components_home_tradly_home_EnablingEntrepreneurs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28294);
/* harmony import */ var _components_home_tradly_home_DeveloperExperience__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24062);
/* harmony import */ var _components_home_tradly_home_Opensource__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23354);
/* harmony import */ var _components_home_tradly_home_BuildingBlocks_BuildingBlocks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93464);
/* harmony import */ var _components_home_tradly_home_Modularity__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54597);
/* harmony import */ var _components_home_tradly_home_AnyDevices__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81054);
/* harmony import */ var _components_home_tradly_home_Integrations__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96792);
/* harmony import */ var _components_home_tradly_home_Studio__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93968);
/* harmony import */ var _components_home_tradly_home_Featuresstack__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3473);
/* harmony import */ var _partials_Cta__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(74756);
/* harmony import */ var _partials_Onboarding_steps_bar__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11421);
/* harmony import */ var _how_mdx__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(74861);
/* harmony import */ var _bfeatures_mdx__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(17094);
/* harmony import */ var _channel_mdx__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(66080);
/* harmony import */ var _checklist_mdx__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(52861);




















function Home() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Simple & Easy way to launch your booking Portal & Website & App"
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Simple & Easy way to launch your booking Portal & Website & App"
                    }, "og:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: " Simple & Easy way to launch your booking Portal & Website & App"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col min-h-screen overflow-hidden ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex-grow",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TradlyHome_FleetHome__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: " max-w-6xl mx-auto pt-20 mb-20 space-y-20 overflow-hidden sm:pt-32 sm:mb-32 sm:space-y-32 md:pt-40 md:mb-40 md:space-y-40",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                    className: "text-center px-8",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "text-gray-900 text-4xl tracking-tight font-extrabold sm:text-5xl",
                                            children: "“Idea into a Product is Hard in many layers”"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "mt-6 max-w-4xl mx-auto text-lg",
                                                    children: "- Make your office or your time a productive one by improving the efficiency of customer management. - Give your users an way to book activities or events anytime they want."
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_how_mdx__WEBPACK_IMPORTED_MODULE_16__["default"], {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_tradly_home_EnablingEntrepreneurs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_tradly_home_Integrations__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_tradly_home_AnyDevices__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_tradly_home_Studio__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_Cta__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_TradlyFooter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 11421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var constant_check_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44902);
/* harmony import */ var _pages_api_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10107);
/* harmony import */ var constant_functions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60538);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99741);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(constant_url__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _store_User_store__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59155);
/* harmony import */ var _store_User_store__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_store_User_store__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_classNames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64920);









var Onboarding_steps_bar = function(param) {
    var component_styles = param.component_styles;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isRegister = ref[0], setIsRegister = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isTemplate = ref1[0], setIsTemplate = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), selectedTemplate = ref2[0], setSelectedTemplate = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isCustomized = ref3[0], setIsCustomized = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isIntegrationAvailable = ref4[0], setIsIntegrationAvailable = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isCustomDomainAvailable = ref5[0], setISCustomDomainAvailable = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isFetching = ref6[0], setIsFetching = ref6[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([
        {
            id: 1,
            name: "Register",
            status: isRegister,
            path: "/signin?to=".concat(constant_url__WEBPACK_IMPORTED_MODULE_6__.site_url).concat(router.asPath)
        },
        {
            id: 2,
            name: "Select Template",
            status: isTemplate,
            path: "/workspace/templates"
        },
        {
            id: 3,
            name: "Customize",
            status: isCustomized,
            path: "/editor"
        },
        {
            id: 4,
            name: "Add Integration",
            status: isIntegrationAvailable,
            path: "/workspace/integrations"
        },
        {
            id: 5,
            name: "Add Domain",
            status: isIntegrationAvailable,
            path: "/workspace/domain"
        }, 
    ]), steps_bar = ref7[0], setSteps_bar = ref7[1];
    // fetching
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setInterval(function() {
            setIsFetching(false);
        }, 3000);
    }, [
        router
    ]);
    // Data fetching
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if ((0,constant_check_auth__WEBPACK_IMPORTED_MODULE_3__/* .check_login */ .f)(router, false)) {
            setIsRegister(true);
        }
        if ((0,constant_functions__WEBPACK_IMPORTED_MODULE_5__.getAuthKey)() !== undefined) {
            (0,_pages_api_api__WEBPACK_IMPORTED_MODULE_4__/* .get_configs */ .WG)((0,constant_functions__WEBPACK_IMPORTED_MODULE_5__.getAuthKey)(), "general,onboarding").then(function(res) {
                if (res.theme) {
                    setIsTemplate(true), setSelectedTemplate(res.theme);
                }
                if (res.app_color_primary) {
                    setIsCustomized(true);
                }
            });
            (0,_pages_api_api__WEBPACK_IMPORTED_MODULE_4__/* .get_configs */ .WG)((0,constant_functions__WEBPACK_IMPORTED_MODULE_5__.getAuthKey)(), "integrations").then(function(response) {
                if (Object.keys(response).length > 0) {
                    setIsIntegrationAvailable(true);
                    //
                    _store_User_store__WEBPACK_IMPORTED_MODULE_7___default().tenant_details(function(resp) {
                        if ((resp === null || resp === void 0 ? void 0 : resp.domain) && !(resp === null || resp === void 0 ? void 0 : resp.domain.includes("tradly.co"))) {
                            setISCustomDomainAvailable(true);
                        }
                    });
                }
            });
        }
    }, [
        router
    ]);
    //open_link
    var open_link = function(step) {
        switch(step.id){
            case 1:
                if (!isRegister) {
                    router.push(step.path);
                } else {
                    alert("You already have registered.");
                }
                break;
            case 2:
                if (isRegister) {
                    if (!isTemplate) {
                        router.push(step.path);
                    } else {
                        alert("You selected a template before.");
                    }
                } else {
                    if (router.pathname === "/templates") {
                        alert("Please sign in or signup first.");
                    } else {
                        router.push(step.path);
                    }
                }
                break;
            case 3:
                if (isRegister) {
                    router.push(step.path);
                } else {
                    alert("Please sign in or signup first.");
                }
                break;
            case 4:
                if (isRegister) {
                    router.push(step.path);
                } else {
                    alert("Please sign in or signup first.");
                }
                break;
            case 5:
                if (isRegister) {
                    router.push(step.path);
                } else {
                    alert("Please sign in or signup first.");
                }
                break;
            default:
                break;
        }
    };
    return (isRegister === false || isTemplate === false || isCustomized === false || isIntegrationAvailable === false || isCustomDomainAvailable === false) && !isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_utils_classNames__WEBPACK_IMPORTED_MODULE_8__.cn)(" w-full mx-auto my-4  pb-10 ", component_styles),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex pb-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: [
                                "w-10 h-10  mx-auto rounded-full text-lg text-white flex items-center",
                                isRegister ? "bg-primary" : "bg-white border-2 border-grey-200", 
                            ].join(" "),
                            children: isRegister ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-white text-center w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-6 w-6 mx-auto my-auto",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M5 13l4 4L19 7"
                                    })
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-gray-500 text-center w-full",
                                children: "1"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[10%] sm:w-[13%] align-center items-center align-middle content-center flex",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full bg-gray-300 rounded items-center align-middle align-center flex-1",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: [
                                    " text-xs leading-none py-1 text-center text-grey-darkest rounded ",
                                    isRegister ? "bg-primary" : "bg-gray-300", 
                                ].join(" "),
                                style: {
                                    width: "100%"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: [
                                "w-10 h-10  mx-auto rounded-full text-lg text-white flex items-center",
                                isTemplate ? "bg-primary" : "bg-white border-2 border-grey-200", 
                            ].join(" "),
                            children: isTemplate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-white text-center w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-6 w-6 mx-auto my-auto",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M5 13l4 4L19 7"
                                    })
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-gray-500 text-center w-full",
                                children: "2"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[10%] sm:w-[13%] align-center items-center align-middle content-center flex",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full bg-gray-300 rounded items-center align-middle align-center flex-1",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: [
                                    " text-xs leading-none py-1 text-center text-grey-darkest rounded ",
                                    isRegister && isTemplate ? "bg-primary" : "bg-gray-300", 
                                ].join(" "),
                                style: {
                                    width: "100%"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: [
                                "w-10 h-10  mx-auto rounded-full text-lg text-white flex items-center",
                                isCustomized ? "bg-primary" : "bg-white border-2 border-grey-200", 
                            ].join(" "),
                            children: isCustomized ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-white text-center w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-6 w-6 mx-auto my-auto",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M5 13l4 4L19 7"
                                    })
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-gray-500 text-center w-full",
                                children: "3"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[10%] sm:w-[13%] align-center items-center align-middle content-center flex",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full bg-gray-300 rounded items-center align-middle align-center flex-1",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: [
                                    " text-xs leading-none py-1 text-center text-grey-darkest rounded ",
                                    isRegister && isTemplate && isCustomized ? "bg-primary" : "bg-gray-300", 
                                ].join(" "),
                                style: {
                                    width: "100%"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: [
                                "w-10 h-10  mx-auto rounded-full text-lg text-white flex items-center",
                                isIntegrationAvailable ? "bg-primary" : "bg-white border-2 border-grey-200", 
                            ].join(" "),
                            children: isIntegrationAvailable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-white text-center w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-6 w-6 mx-auto my-auto",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M5 13l4 4L19 7"
                                    })
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-gray-500 text-center w-full",
                                children: "4"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[10%] sm:w-[13%] align-center items-center align-middle content-center flex",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full bg-gray-300 rounded items-center align-middle align-center flex-1",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: [
                                    " text-xs leading-none py-1 text-center text-grey-darkest rounded ",
                                    isRegister && isTemplate && isCustomized && isIntegrationAvailable ? "bg-primary" : "bg-gray-300", 
                                ].join(" "),
                                style: {
                                    width: "100%"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: [
                                "w-10 h-10  mx-auto rounded-full text-lg text-white flex items-center",
                                isCustomDomainAvailable ? "bg-primary" : "bg-white border-2 border-grey-200", 
                            ].join(" "),
                            children: isCustomDomainAvailable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-white text-center w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-6 w-6 mx-auto my-auto",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M5 13l4 4L19 7"
                                    })
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-gray-500 text-center w-full",
                                children: "5"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex text-xs content-center text-center",
                children: steps_bar.map(function(step) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-1/5",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: [
                                "hover:text-primary"
                            ].join(" "),
                            onClick: function() {
                                return open_link(step);
                            },
                            children: step.name
                        })
                    });
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Onboarding_steps_bar);


/***/ }),

/***/ 59155:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _asyncToGenerator = (__webpack_require__(60932)/* ["default"] */ .Z);
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
var getUserDetails = (__webpack_require__(10107)/* .getUserDetails */ .M_);
var ref = __webpack_require__(9669), axios = ref.default;
var ref1 = __webpack_require__(60538), getAuthKey = ref1.getAuthKey, getSelectedTenantDetails = ref1.getSelectedTenantDetails;
module.exports = {
    user_details: function() {
        var _ref = _asyncToGenerator(function(onSuccess, onError) {
            return _tsGenerator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getUserDetails(getAuthKey()).then(function(res) {
                                return onSuccess(res === null || res === void 0 ? void 0 : res.user);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(onSuccess, onError) {
            return _ref.apply(this, arguments);
        };
    }(),
    tenant_details: function() {
        var _ref = _asyncToGenerator(function(onSuccess, onError) {
            return _tsGenerator(this, function(_state) {
                axios.get("/api/user_tenants_details", {
                    params: {
                        auth_key: getAuthKey()
                    }
                }).then(function(res) {
                    onSuccess(getSelectedTenantDetails(res.data.data.tenants));
                });
                return [
                    2
                ];
            });
        });
        return function(onSuccess, onError) {
            return _ref.apply(this, arguments);
        };
    }()
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [73320,85220,96401,25675,19702,90585,17114,48893,48299,48777,26852,5679,15592,589,28294,59056,49774,92888,40179], function() { return __webpack_exec__(90958); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);